import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import MassBalanceHeader from "./Header";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
import MassBalanceContent from "./MassBalanceContent";

const ProdMassBalance47Components = ({ productId }) => {
  const { t } = useTranslation();
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="mass-balance-47-container" id="mass-balance-47-id">
      <MassBalanceHeader productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="mass-balance-47-content">
          <MassBalanceContent productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdMassBalance47Components;

